import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a0c67a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup"
}
const _hoisted_2 = { class: "df mt-15 search-wrapper" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "df jc-right" }
const _hoisted_7 = { class: "body" }
const _hoisted_8 = {
  key: 1,
  class: "d-popup"
}
const _hoisted_9 = { class: "d-body" }
const _hoisted_10 = { class: "d-body__buttons" }
const _hoisted_11 = { class: "df jc-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_drive_all_files = _resolveComponent("drive-all-files")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, {
          customTitle: _ctx.$localize('drive.view.add.files.from.drive'),
          countPadding: ""
        }, {
          bottom: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_app_search, {
                  modelValue: _ctx.driveStore.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driveStore.search) = $event)),
                  onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.search = ''))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["mrl-16 icon", _ctx.driveStore.isGridPhotoView ? 'icon-tiles-2' : 'icon-tiles']),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.driveStore.switchPhotoView && _ctx.driveStore.switchPhotoView(...args)))
              }, null, 2)
            ])
          ]),
          "top-left": _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
              class: "back-link"
            }, _hoisted_5)
          ]),
          "top-right": _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fileUpdate && _ctx.fileUpdate(...args)), ["prevent"])),
                class: "link"
              }, _toDisplayString(_ctx.$localize('drive.done.button')), 1)
            ])
          ]),
          _: 1
        }, 8, ["customTitle"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_drive_all_files, {
            selector: "",
            "hide-footer": "",
            "temporary-files": _ctx.temporaryFiles
          }, null, 8, ["temporary-files"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
              class: "back-link"
            }, _toDisplayString(_ctx.$localize('drive.view.add.photos.from.drive.backtext')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fileUpdate && _ctx.fileUpdate(...args)), ["prevent"])),
                class: "link"
              }, _toDisplayString(_ctx.$localize('drive.done.button')), 1)
            ])
          ]),
          _createVNode(_component_drive_all_files, {
            selector: "",
            "hide-footer": "",
            "temporary-files": _ctx.temporaryFiles
          }, null, 8, ["temporary-files"])
        ])
      ]))
}